"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;
function format(Component) {
  Component.prototype.getValueLink = function (_props) {
    var props = _props || this.props;
    return props.valueLink || {
      value: props.value,
      requestChange: props.onChange
    };
  };
}


//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/rc-datepicker/lib/utils/valueLink.js
// module id = 970
// module chunks = 0